import { combineReducers } from 'redux'

import { reducer as router } from './modules/router'
import { reducer as snackbar } from './modules/snackbar'
import { reducer as network } from './modules/network'
import { reducer as auth } from './modules/auth'
import { reducer as fileupload } from './modules/fileupload'
import { reducer as admin } from './modules/admin'
import { reducer as project } from './modules/project'
import { reducer as booking } from './modules/booking'
import { reducer as bookingform } from './modules/bookingform'

const reducers = {
  router,
  snackbar,
  network,
  auth,
  fileupload,
  admin,
  project,
  booking,
  bookingform,
}

export default combineReducers(reducers)
